import React from 'react'
import styles from '../../UserCard.module.scss'
import { convertDateToSubmit, daysToYearsMonthsDays } from '../../../../helpers/timeHelper'
import { MailSvg } from '../../../../UI/Icons/MailSvg'
import { PhoneSvg } from '../../../../UI/Icons/PhoneSvg'

const ColleagueItem = ({ colleague, isCompactView = false }) => {
  if (isCompactView) {
    const {
      first_name,
      last_name,
      middle_name,
      rank,
      duration,
      date_from,
      date_to,
      vessel_name,
      vessel_date_from,
      vessel_date_to,
      emails,
      phones,
      avatar,
      avatar_url,
      photo,
      photo_url,
      image,
      image_url,
      picture,
    } = colleague || {}

    const name =
      first_name || last_name || middle_name
        ? `${first_name || ''} ${last_name || ''} ${middle_name || ''}`.trim()
        : 'No name'

    const initials =
      name
        .split(' ')
        .filter(Boolean)
        .slice(0, 2)
        .map((s) => s[0]?.toUpperCase())
        .join('') || '—'

    const email = Array.isArray(emails) ? emails.find((e) => e?.is_general)?.contact || emails[0]?.contact : undefined
    const phone = Array.isArray(phones) ? phones.find((p) => p?.is_general)?.contact || phones[0]?.contact : undefined

    const avatarSrc =
      picture?.file_mini || picture?.file || avatar_url || avatar || photo_url || photo || image_url || image

    return (
      <article className={styles.colleaguesCard}>
        <div className={styles.colleaguesCardMain}>
          <div className={styles.colleaguesCardAvatar}>
            {avatarSrc ? (
              <img className={styles.colleaguesCardAvatarImg} src={avatarSrc} alt={name} />
            ) : (
              <div className={styles.colleaguesCardAvatarFallback}>{initials}</div>
            )}
          </div>

          <div className={styles.colleaguesCardInfo}>
            <h5 className={styles.colleaguesCardName}>{name}</h5>
            <p className={styles.colleaguesCardRank}>{rank || '—'}</p>

            <ul className={styles.colleaguesCardMeta}>
              <li className={styles.colleaguesCardMetaItem}>
                <div className={styles.colleaguesCardMetaLabel}>Vessel</div>
                <div className={styles.colleaguesCardMetaValue}>{vessel_name || '—'}</div>
              </li>
              <li className={styles.colleaguesCardMetaItem}>
                <div className={styles.colleaguesCardMetaLabel}>Period</div>
                <div className={styles.colleaguesCardMetaValue}>
                  {convertDateToSubmit(date_from)} - {convertDateToSubmit(date_to) || 'currently'}
                </div>
              </li>
            </ul>
            {(email || phone) && (
              <div className={styles.colleaguesCardActions}>
                {email && (
                  <a className={styles.colleaguesCardAction} href={`mailto:${email}`}>
                    <MailSvg /> Email
                  </a>
                )}
                {phone && (
                  <a className={styles.colleaguesCardAction} href={`tel:${phone}`}>
                    <PhoneSvg /> Call
                  </a>
                )}
              </div>
            )}
          </div>
        </div>
      </article>
    )
  }

  const { colleagues, vessel_name, date_from, date_to } = colleague

  return (
    <article>
      <div className={styles.colleague}>
        <p>
          <span className={styles.colleague_vessel_name}>{vessel_name}</span> (Period{' '}
          <span className={styles.colleague_vessel_name}>
            {date_from} - {date_to || 'currently'}
          </span>
          )
        </p>
      </div>
      <ul className={styles.colleague_list}>
        {colleagues &&
          colleagues.map((item, index) => {
            const { date_from, date_to, duration, first_name, last_name, middle_name, rank } = item
            const { years, months, remainingDays } = daysToYearsMonthsDays(duration)

            return (
              <li className={styles.colleague_list_item} key={index}>
                <span>
                  {first_name || last_name || middle_name ? `${first_name} ${last_name} ${middle_name}` : 'No name'}
                </span>
                <span>{rank}</span>
                <span>
                  {years > 0 && `${years}y `}
                  {months > 0 && `${months}m `}
                  {remainingDays > 0 && `${remainingDays}d `}
                  {`(${date_from} - ${date_to || 'currently'})`}
                </span>
              </li>
            )
          })}
      </ul>
    </article>
  )
}

export default ColleagueItem
